import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, PhoneCall, TrendingUp } from 'lucide-react';
import { formatRate } from '@/utils/dateFieldStandards';
import type { FollowUpRecoveryMetrics } from '@/types/reports';

interface FollowUpRecoveryPanelProps {
  data: FollowUpRecoveryMetrics;
}

export function FollowUpRecoveryPanel({ data }: FollowUpRecoveryPanelProps) {
  const metrics = [
    {
      label: 'Lost leads',
      value: data.lost_leads.toString(),
      subValue: 'Marked lost by a CSR in this cohort',
      icon: PhoneCall,
      color: 'text-destructive',
    },
    {
      label: 'Follow-up attempted',
      value: formatRate(data.follow_up_attempted_rate),
      subValue: `${data.follow_up_attempted_count} of ${data.lost_leads} called or texted after being marked lost`,
      icon: Clock,
      color: (data.follow_up_attempted_rate ?? 0) >= 80 ? 'text-success' : 'text-warning',
    },
    {
      label: 'Recovered',
      value: data.recovered_count.toString(),
      subValue: `${formatRate(data.recovered_rate)} of lost leads booked afterwards`,
      icon: TrendingUp,
      color: 'text-success',
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Follow-up Recovery</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {metrics.map((metric) => (
            <div key={metric.label} className="text-center p-3 rounded-lg bg-muted/30">
              <metric.icon className={`h-5 w-5 mx-auto mb-2 ${metric.color}`} />
              <div className="text-lg font-bold">{metric.value}</div>
              <div className="text-xs text-muted-foreground">{metric.label}</div>
              <div className="text-xs text-muted-foreground mt-1">{metric.subValue}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
